// auth
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";

//profile
export const ADD_ACCOUNT = "ADD_ACCOUNT";
export const GET_PROFILE = "GET_PROFILE";
export const GET_LIST_ACCOUNT = "GET_LIST_ACCOUNT";
export const PUT_LIST_ACCOUNT = "PUT_LIST_ACCOUNT";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const GET_PROFILE_CTV = "GET_PROFILE_CTV";
export const PUT_ACCOUNT_CTV = "PUT_ACCOUNT_CTV";

//product
export const GET_CATEGORY = "GET_CATEGORY";
export const POST_CATEGORY = "POST_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";

export const GET_SUBCATEGORY = "GET_SUBCATEGORY";
export const POST_SUBCATEGORY = "POST_SUBCATEGORY";
export const POST_CHILDCATEGORY = "POST_CHILDCATEGORY";

export const GET_PRODUCT = "GET_PRODUCT";
export const POST_PRODDUCT = "POST_PRODDUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_LIST_PRODUCT = "UPDATE_LIST_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const SEARCH_PRODUCT = "SEARCH_PRODUCT";
export const GET_PRODUCT_BY_ID = "GET_PRODUCT_BY_ID";
export const GET_PRICE_HISTORY_PRODUCT = "GET_PRICE_HISTORY_PRODUCT";
export const PUT_PRICE_HISTORY_PRODUCT = "PUT_PRICE_HISTORY_PRODUCT";
export const GET_PRODUCT_BY_ARRAY_ID = "GET_PRODUCT_BY_ARRAY_ID";
export const PUT_PRODUCT_EXCEL = "PUT_PRODUCT_EXCEL";
export const PUT_PRODUCT_EXCEL_MH = "PUT_PRODUCT_EXCEL_MH";
export const GET_FULL_PRODUCT_EXCEL = "GET_FULL_PRODUCT_EXCEL";
export const GET_LIST_PRODUCT_GSHOP = "GET_LIST_PRODUCT_GSHOP";
export const PUT_LIST_PRODUCT_GSHOP = "PUT_LIST_PRODUCT_GSHOP";
export const PUT_PRODUCT_GSHOP = "PUT_PRODUCT_GSHOP";
export const DELETE_PRODUCT_GSHOP = "DELETE_PRODUCT_GSHOP";
export const GET_CATEGORY_GIGA_VN = "GET_CATEGORY_GIGA_VN";
export const GET_SUB_CATEGORY_GIGA_VN = "GET_SUB_CATEGORY_GIGA_VN";
export const COPY_TO_GIGA_VN = "COPY_TO_GIGA_VN";

// ton kho ma MH
export const GET_TON_KHO_PRICE = "GET_TON_KHO_PRICE";

// upload images
export const GET_IMAGE_PRODUCT = "GET_IMAGE_PRODUCT";
export const GET_IMAGE_NEWS = "GET_IMAGE_NEWS";
export const FIND_BY_ID = "FIND_BY_ID";
export const DELETE_IMAGE_PRODUCT = "DELETE_IMAGE_PRODUCT";

export const GET_IMAGE_BANNER = "GET_IMAGE_BANNER";
export const POST_IMAGE_BANNER = "POST_IMAGE_BANNER";
export const PUT_IMAGE_BANNER = "PUT_IMAGE_BANNER";
export const DELETE_IMAGE_BANNER = "DELETE_IMAGE_BANNER";

// comment
export const GET_COMMENT = "GET_COMMENT";
export const POST_COMMENT = "POST_COMMENT";
export const PUT_COMMENT = "PUT_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";

export const GET_KHUYEN_MAI = "GET_KHUYEN_MAI";
export const POST_KHUYEN_MAI = "POST_KHUYEN_MAI";
export const GET_CHI_TIET_KHUYEN_MAI = "GET_CHI_TIET_KHUYEN_MAI";
export const UPDATE_KHUYEN_MAI = "UPDATE_KHUYEN_MAI";
export const DELETE_KHUYEN_MAI = "DELETE_KHUYEN_MAI";
export const SEARCH_KHUYEN_MAI = "SEARCH_KHUYEN_MAI";
export const GET_RESERVE = "GET_RESERVE";

export const GET_ORDER = "GET_ORDER";
export const GET_ORDER_ID = "GET_ORDER_ID";
export const CONFIRM_ORDER = "CONFIRM_ORDER";
export const SEARCH_CHECKOUT = "SEARCH_CHECKOUT";
export const GET_ORDER_GSHOP = "GET_ORDER_GSHOP";
export const GET_ORDER_ID_GSHOP = "GET_ORDER_ID_GSHOP";
export const CONFIRM_ORDER_GSHOP = "CONFIRM_ORDER_GSHOP";
export const GET_HISTORY = "GET_HISTORY";
export const PUT_HISTORY = "PUT_HISTORY";

// brand
export const GET_SECTION = "GET_SECTION";
export const GET_SECTION_ID = "GET_SECTION_ID";
export const POST_SECTION = "POST_SECTION";
export const UPDATE_SECTION = "UPDATE_SECTION";
export const DELETE_SECTION = "DELETE_SECTION";

// brand
export const GET_BRAND = "GET_BRAND";
export const GET_SEARCH_BRAND = "GET_SEARCH_BRAND";
export const POST_BRAND = "POST_BRAND";
export const UPDATE_BRAND = "UPDATE_BRAND";
export const DELETE_BRAND = "DELETE_BRAND";

export const GET_BRANCH_CMS = "GET_BRANCH_CMS";
export const POST_BRANCH = "POST_BRANCH";
export const UPDATE_BRANCH = "UPDATE_BRANCH";
export const DELETE_BRANCH = "DELETE_BRANCH";

//voucher
export const GET_VOUCHER = "GET_VOUCHER";
export const POST_VOUCHER = "POST_VOUCHER";
export const PUT_VOUCHER = "PUT_VOUCHER";
export const DELETE_VOUCHER = "DELETE_VOUCHER";

// price list
export const GET_PRICE_LIST_SHOWROOM = "GET_PRICE_LIST_SHOWROOM";
export const PUT_PRICE_LIST_SHOWROOM = "PUT_PRICE_LIST_SHOWROOM";
export const SEARCH_PRICE_LIST_SHOWROOM = "SEARCH_PRICE_LIST_SHOWROOM";
export const GET_PRICE_LIST = "GET_PRICE_LIST";
export const POST_PRICE_LIST = "POST_PRICE_LIST";
export const PUT_PRICE_LIST = "PUT_PRICE_LIST";
export const DELETE_PRICE_LIST = "DELETE_PRICE_LIST";
export const SEARCH_PRICE_LIST = "SEARCH_PRICE_LIST";
export const SYNCH_DATA_CONTENT = "SYNCH_DATA_CONTENT";

// news
export const GET_CATEGORY_NEWS = "GET_CATEGORY_NEWS";
export const POST_CATEGORY_NEWS = "POST_CATEGORY_NEWS";
export const PUT_CATEGORY_NEWS = "PUT_CATEGORY_NEWS";
export const DELETE_CATEGORY_NEWS = "DELETE_CATEGORY_NEWS";
export const GET_SUB_CATEGORY_NEWS = "GET_SUB_CATEGORY_NEWS";
export const POST_SUB_CATEGORY_NEWS = "POST_SUB_CATEGORY_NEWS";
export const PUT_SUB_CATEGORY_NEWS = "PUT_SUB_CATEGORY_NEWS";
export const DELETE_SUB_CATEGORY_NEWS = "DELETE_SUB_CATEGORY_NEWS";

export const GET_NEW_BY_CATE = "GET_NEW_BY_CATE";
export const POST_NEW = "POST_NEW";
export const GET_NEW_BY_ID = "GET_NEW_BY_ID";
export const GET_NEW_BY_SLUG = "GET_NEW_BY_SLUG";
export const PUT_NEW = "PUT_NEW";
export const PUT_LIST_NEW = "PUT_LIST_NEW";
export const DELETE_NEW = "DELETE_NEW";
export const SEARCH_NEW = "SEARCH_NEW";
export const POST_PRODUCT_NEWS = "POST_PRODUCT_NEWS";
export const DELETE_PRODUCT_NEWS = "DELETE_PRODUCT_NEWS";

// flash_sale
export const GET_FLASH_SALE = "GET_FLASH_SALE";
export const POST_FLASH_SALE = "POST_FLASH_SALE";
export const PUT_FLASH_SALE = "PUT_FLASH_SALE";

export const CLEAR_DATA = "CLEAR_DATA";

//name card
export const GET_NAME_CARD = "GET_NAME_CARD";
export const POST_NAME_CARD = "POST_NAME_CARD";
export const PUT_NAME_CARD = "PUT_NAME_CARD";
export const DELETE_NAME_CARD = "DELETE_NAME_CARD";
